<body>
  <app-account-header></app-account-header>
  <div class="clear40"></div>
<div class="d-flex align-items-center auth px-0  mt-5">
  <div class="row w-100 mx-0 mt-5">
    <div class="col-lg-4 mx-auto">
      <label class="txtblack fs-20 semi-bold">Create New Password</label>
      <div class="clear5"></div>
      <div class="auth-form-light bg-white">
      
        <h6 class="fs-16 txtblack semi-bold mb-3">Enter New Password</h6> 
          <div class="form-group">
            <input type="password"  class="form-control forminput {{shownewpassErrorMsg?'border-red':''}}"  [(ngModel)]="newPassword" (input)="newpassErrorMsg();"  placeholder="" autocomplete="off">
            <span class="error-msg" *ngIf="shownewpassErrorMsg">Please Enter New Password</span>

          </div>

          <h6 class="fs-16 txtblack semi-bold mb-3">Confirm New Password</h6> 
          <div class="form-group">
            <input type="password"  class="form-control forminput  {{showconfirmpassErrorMsg?'border-red':''}}"   [(ngModel)]="confirmPassword" (input)="confirmpassErrorMsg();"  placeholder="" autocomplete="off">
            <span class="error-msg" *ngIf="showconfirmpassErrorMsg">Please Enter Confirm Password</span>

          </div>
      

          <div class="mt-3">
            <div class="row">
              
           
                <div class="col-sm-8 col-md-8">
                  <div class="clear20"></div>
                  <a class="btn btn-block  blue-btn semi-bold fs-16" (click)="setPassword()">UPDATE PASSWORD</a>
                 
                </div>
           </div>
          </div>

      </div>
    </div>
  </div>
</div>  
</body>
